module.exports = __webpack_public_path__ + "imgs/team1@1x-min.f4c9e0a7.webp";